import apiURLBuilder from 'core/apiURLBuilder';
import Api from 'services/api';
import preLoaderActions from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import { recordEventStepSuccess } from 'utilities/uTagging';
import { PATH_DEPOSIT_CONFIGURATION } from 'constants/uTagConstants/paths';
import { goToErrorsView } from './errorViewNavigation';

const sendDeposit = () => (dispatch, getState) => {
    const url = apiURLBuilder.getURL('sendDeposit');
    const accessToken = getState().userProfile.accessToken;
    const amount = getState().userProfile.depositValue;

    const currentIndex = getState().steps.get('currentStep');

    const header = {
        Authorization: `Bearer ${accessToken}`,
    };
    const query = {
        amount,
    };

    const payload = {
        header,
        query,
    };

    dispatch(preLoaderActions.showPreLoader());
    Api.post(url, payload).then(
        () => {
            const investmentType = getState().userProfile.investmentType;

            dispatch(stepsActions.enableFinishedAndNextStep());
            dispatch(
                stepsActions.changeCurrentStep({
                    index: currentIndex + 1,
                })
            );

            recordEventStepSuccess(investmentType, PATH_DEPOSIT_CONFIGURATION, 'diseña tu deposito', {
                amount,
                event_name: 'event_success',
                action: 'success',
                format: 'steps',
                component: 'funnel',
                element: 'deposit configuration',
            });

            dispatch(preLoaderActions.hidePreLoader());
        },
        error => {
            dispatch(preLoaderActions.hidePreLoader());
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: url }));
        }
    );
};

export default {
    sendDeposit,
};
